import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { RegisterAppMessageActionRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { RegisterAppMessageActionResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const registerAppMessageAction = (request: RegisterAppMessageActionRequest, options?: CashRequestOptions) =>
  post<RegisterAppMessageActionRequest, RegisterAppMessageActionResponse>(
    '/2.0/cash/register-app-message-action',
    request,
    { ...options, rejectOnError: true }
  )
